import { IQuantity, isGreaterThan as isQuantityGreaterThan, isLessThan as isQuantityLessThan } from '../Core/IQuantity';

export interface ISieveSize {
  Id: SieveSizeId;
  Size?: IQuantity;
  Caption: string;
  IsCommon: boolean;
}

/**
 * The id of a sieve size. Set of fixed strings defined in QESTNet.
 */
export type SieveSizeId =
  | '600_0'
  | '500_0'
  | '450_0'
  | '400_0'
  | '368_0'
  | '300_0'
  | '250_0'
  | '225_0'
  | '200_0'
  | '150_0'
  | '125_0'
  | '112_0'
  | '106_0'
  | '100_0'
  | '90_0'
  | '75_0'
  | '63_0'
  | '53_0'
  | '50_0'
  | '45_0'
  | '40_0'
  | '37_5'
  | '31_5'
  | '28_0'
  | '26_5'
  | '25_0'
  | '22_4'
  | '20_0'
  | '19_0'
  | '16_0'
  | '14_0'
  | '13_5'
  | '13_2'
  | '12_5'
  | '11_2'
  | '10_0'
  | '9_5'
  | '8_0'
  | '7_0'
  | '6_7'
  | '6_3'
  | '5_6'
  | '5_0'
  | '4_75'
  | '4_00'
  | '3_35'
  | '3_175'
  | '2_80'
  | '2_36'
  | '2_00'
  | '1_70'
  | '1_40'
  | '1_18'
  | '1_00'
  | '0_850'
  | '0_710'
  | '0_630'
  | '0_600'
  | '0_500'
  | '0_425'
  | '0_355'
  | '0_300'
  | '0_250'
  | '0_212'
  | '0_200'
  | '0_180'
  | '0_150'
  | '0_125'
  | '0_106'
  | '0_090'
  | '0_075'
  | '0_063'
  | '0_053'
  | '0_045'
  | '0_038'
  | '0_032'
  | '0_025'
  | '0_020'
  | '0_019'
  | '0_0135'
  | '0_009'
  | '0_005'
  | '0_002'
  | 'NO_SIZE';

/**
 * NOTE: This method assumes uom are the same for both sieve sizes
 */
export const isLessThan = (left: ISieveSize | null | undefined, right: ISieveSize | null | undefined) =>
  isQuantityLessThan(left?.Size, right?.Size);

/**
 * NOTE: This method assumes uom are the same for both sieve sizes
 */
export const isGreaterThan = (left: ISieveSize | null | undefined, right: ISieveSize | null | undefined) =>
  isQuantityGreaterThan(left?.Size, right?.Size);

/**
 * NOTE: This method assumes uom are the same for both sieve sizes
 */
export const isLessThanOrEqualTo = (left: ISieveSize | null | undefined, right: ISieveSize | null | undefined) =>
  !isGreaterThan(left, right);

/**
 * NOTE: This method assumes uom are the same for both sieve sizes
 */
export const isGreaterThanOrEqualTo = (left: ISieveSize | null | undefined, right: ISieveSize | null | undefined) =>
  !isLessThan(left, right);

export const getById = (sieves: ISieveSize[], id: SieveSizeId) => sieves?.find((s) => s.Id === id);

export const createSieveSizeGetter = (id: SieveSizeId) => (sieves: ISieveSize[]) => getById(sieves, id);

export const createSieveSizeCaptionGetter = (id: SieveSizeId) => (sieves: ISieveSize[]) => getById(sieves, id)?.Caption;
